import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";

import { SharedModule } from "@shared/shared.module";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Select, Store } from "@ngxs/store";
import { UPDATE_COVERAGE_ALERT, STORE_SHOWED_ONE_ALLIANZ_POP_UP, UPDATE_COVERAGE_TYPE, STORE_COVERAGE_VEHICLE_DETAILS, GET_NCD_ENQUIRY, STORE_NCD_INFO, RESET_VEHICLE_LEVEL_DRIVER_DETAILS } from "@store/sat-motor/sat-motor.action";
import { CoverageComprehensiveComponent } from "@shared/components/coverages/coverage-comprehensive/coverage-comprehensive.component";
import { CoverageThirdPartyComponent } from "@shared/components/coverages/coverage-third-party/coverage-third-party.component";
import { CoverageThirdPartyFireTheftComponent } from "@shared/components/coverages/coverage-third-party-fire-theft/coverage-third-party-fire-theft.component";
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { Observable, Subject, takeUntil } from "rxjs";
import { UserResponse } from "@interfaces/user";
import { FormatDecimalPipe } from "@shared/pipes/format-decimal/format-decimal.pipe";
import { RemoveCommaPipe } from "@shared/pipes/remove-comma/remove-comma.pipe";
import { ScrollToError } from '@shared/classes/scroll-to-error';
import { OneAllianzMessageComponent } from "@shared/components/modal/one-allianz-message/one-allianz-message.component";
import { OkMessageComponent } from "@shared/components/modal/ok-message/ok-message.component";

@Component({
  selector: "app-type-of-coverage",
  standalone: true,
  imports: [SharedModule, CoverageComprehensiveComponent, CoverageThirdPartyComponent, CoverageThirdPartyFireTheftComponent],
  templateUrl: "./type-of-coverage.component.html",
  styleUrl: "./type-of-coverage.component.scss",
})
export class TypeOfCoverageComponent implements OnInit {
  @ViewChild(CoverageComprehensiveComponent) coverageComprehensiveComponentChild: CoverageComprehensiveComponent;
  @ViewChild(CoverageThirdPartyComponent) coverageThirdPartyComponentChild: CoverageThirdPartyComponent;
  @ViewChild(CoverageThirdPartyFireTheftComponent) coverageThirdPartyFireTheftComponentChild: CoverageThirdPartyFireTheftComponent;

  @Input() coverageFmGroup!: FormGroup;
  @Input() partnerInfo: any;
  @Input()
  get coverListLov() {
    return this.coverList;
  }
  set coverListLov(coverList: any) {
    this.coverList = coverList;
  }

  @Output() coverFormChanged = new EventEmitter<any>();
  @Output() calculatePremium = new EventEmitter<any>();

  @Select(SatMotorState.coveragePremium) coveragePremium$: Observable<SatMotorState>;
  @Select(SatMotorState.coverageDefaultDriver) coverageDefaultDriver$: Observable<SatMotorState>;
  okMessageModal?: NxModalRef<OkMessageComponent>;
  private destroy$ = new Subject<void>();

  
  lov: any;
  userInfo: any;
  issuanceInfo: any;
  coverList: any;
  typeOfCoverage: any;
  showTypeOfCoverage = false;
  isComprehensive = false;
  isThirdParty = false;
  isThirdPartyFireTheft = false;
  hasShowedBettermentPopUp: boolean = false;
  alimCustomerEligible: boolean = false;

  vehicleNo: any;

  decimalFmt: any;
  numberFmt: any;

  loaded: boolean = false;

  NCD_WO_NOTIFICATION = [
    "ENQ000", "ENQ014", "ENQ016", "ENQ017", "ENQ030", "ENQ044", "ENQ051", "ENQ057", "ENQ060", "ENQ062", 
    "ENQ063", "ENQ067", "ENQ078", "ENQ079", "ENQ080", "ENQ081", "ENQ088", "ENQ089", "ENQ092", "ENQ096"
  ];

  oneAllianzModal?: NxModalRef<OneAllianzMessageComponent>;
  bettermentModal?: NxModalRef<OkMessageComponent>;

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private readonly dialogService: NxDialogService) {
      this.decimalFmt = new FormatDecimalPipe();
      this.numberFmt = new RemoveCommaPipe();
  }

  ngOnInit() {
    this.lov = this.store.selectSnapshot<any>((state) => state.SatMotorState.lov);
    this.userInfo = this.store.selectSnapshot<UserResponse>((state) => state.UserState.user);
    this.issuanceInfo = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState.motor.step1.issuance);
    this.vehicleNo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1.issuance.vehicleNo);

    this.typeOfCoverage = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coverageType);

    this.setupCoverList(true);

    if (this.typeOfCoverage && this.typeOfCoverage?.coverCode) {
      this.showTypeOfCoverage = true;
      this.setupCoverList(false);
      this.isComprehensive = this.typeOfCoverage.coverCode === "01";
      this.isThirdParty = this.typeOfCoverage.coverCode === "20";
      this.isThirdPartyFireTheft = this.typeOfCoverage.coverCode === "30";
    }
    
    this.coveragePremium$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      if (state && this.loaded) {

        if (this.store.selectSnapshot<any>((state) => state.SatMotorState.skipCoveragePremium)) {
          return;
        }

        const cngeNote = state["cngeNote"];
        if (cngeNote) {
          const riskList = cngeNote["riskList"];
          if (riskList?.length) {
            this.store.dispatch(new STORE_COVERAGE_VEHICLE_DETAILS({ 
              ...Object.keys(riskList[0])
                      .filter((key) => typeof riskList[0][key] !== "object")
                      .reduce((cur, key) => {
                          return Object.assign(cur, { [key]: riskList[0][key] });
                        }, {}) 
            }));
            for (let riskListItem of riskList) {
              const coverList = riskListItem["coverList"];
              if (coverList?.length) {
                for (let coverListItem of coverList) {
                  this.coverageFmGroup.controls["typeOfCoverage"].patchValue(this.transform(coverListItem, true));
                  if (coverListItem["coverCode"] === "20") {
                    this.coverageFmGroup.controls["typeOfCoverage"].patchValue({
                      grossPremium: this.decimalFmt.transform(coverListItem["grossPremium"])
                    });
                  }
                  this.store.dispatch(new UPDATE_COVERAGE_TYPE(this.transform(coverListItem, false)));
                }
              }
            }
          }
        }
      }
    });

    this.loaded = true;
    
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  transform(value, output) {
    let tvalue = { 
      ...value,
      prevNcdVeh: this.vehicleNo 
    };

    ["sumInsured", "excessAmount", "annualPremium", "basicPremium", "grossPremium", "allriderPrem", "ncdPercentage", "ncdAmount"].forEach(v => {
      tvalue = { ...tvalue, [v]: (output ? this.decimalFmt.transform(value[v]) : this.numberFmt.transform(value[v]) ) };
    });
    
    return tvalue;
  }

  private setupCoverList(enabled: boolean) {
    let coverList = JSON.parse(JSON.stringify(this.coverList));
    coverList.forEach((cv: { enable: boolean }) => {
      cv.enable = enabled;
    });
    this.coverList = coverList;
  }

  addCover(cover: any) {
    if (this.validateVehicleDetails()) {
      this.showTypeOfCoverage = true;
      this.typeOfCoverage = cover;
      this.isComprehensive = cover.coverCode === "01";
      this.isThirdParty = cover.coverCode === "20";
      this.isThirdPartyFireTheft = cover.coverCode === "30";
  
      this.setupCoverList(false);

      let vehicleClass;
      const selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState?.data?.step3.coverage?.selectedMakeModel);
      if (selectedMakeModel?.classCode) {
        vehicleClass = selectedMakeModel?.classCode;
      }

      const prevCoverCode = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step3?.coverage?.prevCoverCode);
      if (prevCoverCode) {
        cover = { ...cover, prevCoverCode: prevCoverCode };
      }

      if (!this.store.selectSnapshot<any>(state => state.SatMotorState?.isCancelReplaceCoverNote)) {
        if (["NWOO", "RN"].includes(this.issuanceInfo.issuance.cnoteType)) {
          let vehicleDetailsForm = this.coverageFmGroup.get("vehicleDetails");
          let payload = {
            cnoteType: this.issuanceInfo.issuance.cnoteType,
            cnoteDate: this.issuanceInfo.issuance.effectiveDate,
            productType: this.issuanceInfo.issuance.productCode,
            idType: this.partnerInfo.idType1,
            idNo1: this.partnerInfo.idValue1,
            idNo2: this.partnerInfo.idValue2,
            vehicleUse: vehicleDetailsForm.get("vehicleUse").value,
            vehicleNo: vehicleDetailsForm.get("vehicleNo").value,
            vehicleClass: vehicleClass,
            chassisNo: vehicleDetailsForm.get("vehicleChassis").value,
            coverCode: cover.coverCode,
            previousNcdVehicle: vehicleDetailsForm.get("vehicleNo").value,
            // previousNcdInsurer: previousNcdInsurer
          };
  
          this.store.dispatch(new GET_NCD_ENQUIRY(payload)).subscribe((state) => {
            let ncdInfo = state.SatMotorState.ncdEnquiryDetails;
            if (ncdInfo) {
              this.store.dispatch(new STORE_NCD_INFO(ncdInfo));
              if (ncdInfo.ismResCode) {
                if (this.NCD_WO_NOTIFICATION.includes(ncdInfo.ismResCode)) {
                  this.coverFormChanged.emit(cover);
                }
                else {
                  this.dialogService.open(OkMessageComponent, {
                    disableClose: true,
                    width: "400px", data: { message: ncdInfo.errMsg, },
                  }).afterClosed().subscribe((result) => {
                    this.coverFormChanged.emit(cover);
                  });
                }
              } else {
                this.dialogService.open(OkMessageComponent, {
                  disableClose: true,
                  width: "400px", data: { message: ncdInfo.errMsg, },
                }).afterClosed().subscribe((result) => {
                  this.coverFormChanged.emit(cover);
                });
              }
            } else {
              this.dialogService.open(OkMessageComponent, {
                disableClose: true,
                width: "400px",  data: { message: "NCD Not Allowed = 0%. Unable to connect to ISM NCD System. Please retry or contact System Administrator.", },
              }).afterClosed().subscribe((result) => {
                this.coverFormChanged.emit(cover);
              });
            }
            this.setNcdButton(true);
          });
          return;
        }
      }

      this.coverFormChanged.emit(cover);
    }
  }

  onCoverDeleted() {
    this.isComprehensive = this.isThirdParty = this.isThirdPartyFireTheft = false;
    this.setupCoverList(true);
    this.store.dispatch(new STORE_SHOWED_ONE_ALLIANZ_POP_UP(false)).subscribe(() => {
      this.store.dispatch(new UPDATE_COVERAGE_ALERT({ alimCustomerEligible: false, alimCustomerEligibleShowed: false }));
    });
    this.hasShowedBettermentPopUp = false;
    this.store.dispatch(new UPDATE_COVERAGE_ALERT({ bettermentEligible: false, bettermentEligibleShowed: false }));
    this.store.dispatch(new RESET_VEHICLE_LEVEL_DRIVER_DETAILS());
  }

  onCoverFormChanged(data) {
    this.calculatePremium.emit(data);
  }

  openPopupOneAllianz() {
    if (!this.store.selectSnapshot<boolean>((state) => state.SatMotorState.data?.hasShowedOneAllianzPopUp)) {
      let showPrompt = true;
      let isNonEligibleOneAllianz = false;
      let oneAllianzData = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step2.oneAllianzData ?? null);
      this.alimCustomerEligible = this.store.selectSnapshot<boolean>((state) => state.SatMotorState.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0]?.alimCustomerEligible);

      if (oneAllianzData) {
        if (oneAllianzData.oriAlimCustomerIndi === 'YES' && (oneAllianzData.alimCustomerIndi === 'NO' && this.alimCustomerEligible)){
          isNonEligibleOneAllianz = true;

        } else if (oneAllianzData.oriAlimCustomerIndi === 'YES' && oneAllianzData.alimCustomerIndi === 'YES' && this.alimCustomerEligible) {
          isNonEligibleOneAllianz = false;

        } else if ((oneAllianzData.oriAlimCustomerIndi === 'NO' || !oneAllianzData.oriAlimCustomerIndi) && oneAllianzData.alimCustomerIndi === 'YES' && this.alimCustomerEligible) {
          isNonEligibleOneAllianz = false;

        } else {
          showPrompt = false;
        }
      }

      if (showPrompt) {
      
          this.oneAllianzModal = this.dialogService.open(OneAllianzMessageComponent, {
            showCloseIcon: false,
            disableClose: true,
            width: "400px",
            maxWidth: "400px",
            data: {
              showNonEligible: isNonEligibleOneAllianz
            }
          });
      }

      this.oneAllianzModal.afterClosed().subscribe((result) => {
        this.store.dispatch(new STORE_SHOWED_ONE_ALLIANZ_POP_UP(true)).subscribe(() => {
          this.store.dispatch(new UPDATE_COVERAGE_ALERT({ alimCustomerEligible: false, alimCustomerEligibleShowed: true }));
          this.callTypeOfCoverageComponent("callExtraCoverageCalculatePremium");
        });
      });
    }
  }

  openPopupBetterment() {
    if (!this.hasShowedBettermentPopUp) {
      this.hasShowedBettermentPopUp = true;
      this.bettermentModal = this.dialogService.open(OkMessageComponent, {
        showCloseIcon: false,
        disableClose: true,
        width: "400px",
        maxWidth: "400px",
        data: {
          message: "Your vehicle is subject to betterment, kindly consider purchasing this coverage."
        }
      });

      this.bettermentModal.afterClosed().subscribe((result) => {
        //this.hasShowedBettermentPopUp = true;
        this.store.dispatch(new UPDATE_COVERAGE_ALERT({ bettermentEligible: false, bettermentEligibleShowed: true }));
      });
    }

  }
  
  validateVehicleDetails() {
    let vehicleDetailsFm = ((this.coverageFmGroup.controls["vehicleDetails"]) as FormGroup); 
    if (!vehicleDetailsFm.controls["makeModel"].valid) {
      vehicleDetailsFm.controls["makeModel"].markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
      return false;
    }
    return true;
  }

  callTypeOfCoverageComponent(methodName: any){
    if(this.isComprehensive){
      return this.coverageComprehensiveComponentChild.callComprehensiveComponent(methodName);

    }else if(this.isThirdParty){
      return this.coverageThirdPartyComponentChild.callThirdPartyComponent(methodName);

    }else if(this.isThirdPartyFireTheft){
      return this.coverageThirdPartyFireTheftComponentChild.callThirdPartyFireTheftComponent(methodName);
    }

    return true;
  }

  getNcdButton(coverType) : ElementRef {
    if (coverType) {
      if (coverType === "01") {
        return this.coverageComprehensiveComponentChild.getNcdBtn();
      } else if(coverType === "20") {
        return this.coverageThirdPartyComponentChild.getNcdBtn();
      } else if(coverType === "30") {
        return this.coverageThirdPartyFireTheftComponentChild.getNcdBtn();
      }
    }
    return null;
  }

  setNcdButton(disabled: boolean) {
    const coverCode = this?.typeOfCoverage?.coverCode;
    if (coverCode) {
      if (coverCode === "01") {
        this.coverageComprehensiveComponentChild.setNcdBtn(disabled);
      } else if(coverCode === "20") {
        this.coverageThirdPartyComponentChild.setNcdBtn(disabled);
      } else if(coverCode === "30") {
        return this.coverageThirdPartyFireTheftComponentChild.setNcdBtn(disabled);
      }
    }
  }
}
